<template>
  <div class="col-xs-12 col-md-4">
    <form-group-search-select
      v-if="cursos"
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="cursos"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="atualizarSerie($event)"
      @change="atualizarSerie($event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import CursoService from "../../../../domain/corpore/CursoService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "c-protocolo-serie-colegio",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean,
    cursoId: null
  },
  mounted() {
    this.$el.value = this.value;
  },
  asyncComputed: {
    cursos() {
      const cursoService = new CursoService(this.$http);
      return cursoService
        .getCursosColegio()
        .then(result => {
          return result.map(curso => ({
            value: curso.CODCURSO,
            text: curso.NOME
          }));
        })
        .catch(err => {
          SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
        });
    }
  },
  methods: {
    atualizarSerie(value) {
      this.formValues.cursoId = value;
      this.$emit("input", value);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/SerieColegio.vue